import { type FC, type PropsWithChildren } from 'react';

import styles from './RowWithFade.css';

interface IRowWithFadeProps {
  fadeWidth?: number;
}

export const RowWithFade: FC<PropsWithChildren<IRowWithFadeProps>> = ({ children, fadeWidth = 30 }) => {
  return (
    <div className={styles['row-with-fade']}>
      {children}
      <div className={styles['row-with-fade--fadded']} style={{ width: fadeWidth }} />
    </div>
  );
};
